import React, { Component } from 'react';
import {Link} from 'react-router-dom'

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyData: null,
            loading: true,
            error: null
        }
    }

    componentDidMount() {
        this.fetchCompanyData();
    }

    fetchCompanyData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const response = await fetch('https://asc-admin.vercel.app/api/company/68ebabc1c3db3fcb7ac32696');
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const result = await response.json();
            
            if (result.success && result.data) {
                this.setState({
                    companyData: result.data,
                    loading: false
                });
            } else {
                throw new Error('Invalid data format from company API');
            }
            
        } catch (error) {
            console.error('Error fetching company data:', error);
            this.setState({
                loading: false,
                error: error.message
            });
        }
    }

    renderCompanyInfo() {
        const { companyData, loading, error } = this.state;

        if (loading) {
            return (
                <div className="widget widget_text">
                    <div className="textwidget">
                        <p>
                            <img src="assets/img/asc-logo-white.png" alt="ASC Construction" width={170} height={34} />
                        </p>
                        <div className="loading-spinner">Loading company info...</div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="widget widget_text">
                    <div className="textwidget">
                        <p>
                            <img src="assets/img/asc-logo-white.png" alt="ASC Construction" width={170} height={34} />
                        </p>
                        <p className="margin-bottom-15">We have over 15 years of experience able to help you 24 hours a day.</p>
                        <ul>
                            <li>
                                <div className="inner">
                                    <span className="fa fa-map-marker" />
                                    <span className="text">Mumbai, <span className="sl">India</span></span>
                                </div>
                            </li>
                            <li>
                                <div className="inner">
                                    <span className="fa fa-phone" />
                                    <span className="text">CALL US : (+91) 70213 89253</span>
                                </div>
                            </li>
                            <li className="margin-top-7">
                                <div className="inner">
                                    <span className=" font-size-14 fa fa-envelope" />
                                    <span className="text">contact@asc-construction.in</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            );
        }

        return (
            <div className="widget widget_text">
                <div className="textwidget">
                    <p>
                        <img 
                            src={companyData.mainLogo || "assets/img/asc-logo-white.png"} 
                            alt="ASC Construction" 
                            width={170} 
                            height={34} 
                        />
                    </p>
                    <p className="margin-bottom-15">
                        {companyData.name || "ASC Construction"} - We have over 15 years of experience able to help you 24 hours a day.
                    </p>
                    <ul>
                        <li>
                            <div className="inner">
                                <span className="fa fa-map-marker" />
                                <span className="text">
                                    {companyData.contact?.address ? 
                                        `${companyData.contact.address.street}, ${companyData.contact.address.city}` : 
                                        "Mumbai"
                                    }, 
                                    <span className="sl">
                                        {companyData.contact?.address?.country || "India"}
                                    </span>
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="inner">
                                <span className="fa fa-phone" />
                                <span className="text">
                                    CALL US : {companyData.contact?.phone || "(+91) 70213 89253"}
                                </span>
                            </div>
                        </li>
                        <li className="margin-top-7">
                            <div className="inner">
                                <span className="font-size-14 fa fa-envelope" />
                                <span className="text">
                                    {companyData.contact?.email || "contact@asc-construction.in"}
                                </span>
                            </div>
                        </li>
                        {companyData.officeTime && (
                            <li className="margin-top-7">
                                <div className="inner">
                                    <span className="fa fa-clock-o" />
                                    <span className="text">
                                        Office Hours: {companyData.officeTime.start} - {companyData.officeTime.end} ({companyData.officeTime.timezone})
                                    </span>
                                </div>
                            </li>
                        )}
                    </ul>

                    {/* Social Media Links */}
                    {companyData.socialLinks && (
                        <div className="social-links margin-top-20">
                            <h4 className="widget-title margin-bottom-15"><span>FOLLOW US</span></h4>
                            <div className="social-icons">
                                {companyData.socialLinks.twitter && (
                                    <a href={companyData.socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="social-icon">
                                        <span className="fa fa-twitter" />
                                    </a>
                                )}
                                {companyData.socialLinks.linkedin && (
                                    <a href={companyData.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="social-icon">
                                        <span className="fa fa-linkedin" />
                                    </a>
                                )}
                                {companyData.socialLinks.instagram && (
                                    <a href={companyData.socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social-icon">
                                        <span className="fa fa-instagram" />
                                    </a>
                                )}
                                {companyData.socialLinks.facebook && (
                                    <a href={companyData.socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="social-icon">
                                        <span className="fa fa-facebook" />
                                    </a>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        return (
            <footer id="footer" className="clearfix">
                <div id="footer-widgets" className="container">
                    <div className="themesflat-row gutter-30">
                        <div className="col span_1_of_3">
                            {this.renderCompanyInfo()}
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                        </div>{/* /.col */}
                        
                        <div className="col span_1_of_3">
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={0} />
                            <div className="widget widget_lastest">
                                <h2 className="widget-title"><span>RECENT POSTS</span></h2>
                                <ul className="lastest-posts data-effect clearfix">
                                    <li className="clearfix">
                                        <div className="thumb data-effect-item has-effect-icon">
                                            <img src="assets/img/news/post-1-65x65.jpg" alt="Smart Building" />
                                            <div className="overlay-effect bg-color-2" />
                                            <div className="elm-link">
                                                <Link to="page-blog-single.html" className="icon-2" />
                                            </div>
                                        </div>
                                        <div className="text">
                                            <h3><Link to="page-blog-single.html">SMART BUILDING WITH CONCRETE SUSTAINABLE</Link></h3>
                                            <span className="post-date"><span className="entry-date">29 June 2018</span></span>
                                        </div>
                                    </li>
                                    <li className="clearfix">
                                        <div className="thumb data-effect-item has-effect-icon">
                                            <img src="assets/img/news/post-2-65x65.jpg" alt="Hi-Tech Wooden House" />
                                            <div className="overlay-effect bg-color-2" />
                                            <div className="elm-link">
                                                <Link to="page-blog-single.html" className="icon-2" />
                                            </div>
                                        </div>
                                        <div className="text">
                                            <h3><Link to="page-blog-single.html">HI-TECH WOODEN HOUSE BUILT WITHOUT GLUE</Link></h3>
                                            <span className="post-date"><span className="entry-date">31 June 2018</span></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>{/* /.widget_lastest */}
                        </div>{/* /.col */}
                        
                        <div className="col span_1_of_3">
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={35} data-smobile={35} />
                            <div className="widget widget_tags">
                                <h2 className="widget-title margin-bottom-30"><span>TAGS</span></h2>
                                <div className="tags-list">
                                    <Link to="#">Building</Link>
                                    <Link to="#">Smart House</Link>
                                    <Link to="#">Construction</Link>
                                    <Link to="#">Villa</Link>
                                    <Link to="#">Residential</Link>
                                    <Link to="#">Interior</Link>
                                    <Link to="#">Resort</Link>
                                    <Link to="#">Commercial</Link>
                                </div>
                            </div>
                        </div>{/* /.col */}
                        
                        <div className="col span_1_of_3">
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={35} data-smobile={35} />
                            <div className="widget widget_instagram">
                                <h2 className="widget-title margin-bottom-30"><span>INSTAGRAM PHOTOS</span></h2>
                                <div className="instagram-wrap data-effect clearfix col3 g10">
                                    <div className="instagram_badge_image has-effect-icon">
                                        <Link to="#" target="_blank" className="data-effect-item">
                                            <span className="item"><img src="assets/img/instagram/instagram-1-83x83.jpg" alt="Instagram" /></span>
                                            <div className="overlay-effect bg-color-2" />
                                            <div className="elm-link">
                                                <span className="icon-3" />
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="instagram_badge_image has-effect-icon">
                                        <Link to="#" target="_blank" className="data-effect-item">
                                            <span className="item"><img src="assets/img/instagram/instagram-2-83x83.jpg" alt="Instagram" /></span>
                                            <div className="overlay-effect bg-color-2" />
                                            <div className="elm-link">
                                                <span className="icon-3" />
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="instagram_badge_image has-effect-icon">
                                        <Link to="#" target="_blank" className="data-effect-item">
                                            <span className="item"><img src="assets/img/instagram/instagram-3-83x83.jpg" alt="Instagram" /></span>
                                            <div className="overlay-effect bg-color-2" />
                                            <div className="elm-link">
                                                <span className="icon-3" />
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="instagram_badge_image has-effect-icon">
                                        <Link to="#" target="_blank" className="data-effect-item">
                                            <span className="item"><img src="assets/img/instagram/instagram-4-83x83.jpg" alt="Instagram" /></span>
                                            <div className="overlay-effect bg-color-2" />
                                            <div className="elm-link">
                                                <span className="icon-3" />
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="instagram_badge_image has-effect-icon">
                                        <Link to="#" target="_blank" className="data-effect-item">
                                            <span className="item"><img src="assets/img/instagram/instagram-5-83x83.jpg" alt="Instagram" /></span>
                                            <div className="overlay-effect bg-color-2" />
                                            <div className="elm-link">
                                                <span className="icon-3" />
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="instagram_badge_image has-effect-icon">
                                        <Link to="#" target="_blank" className="data-effect-item">
                                            <span className="item"><img src="assets/img/instagram/instagram-6-83x83.jpg" alt="Instagram" /></span>
                                            <div className="overlay-effect bg-color-2" />
                                            <div className="elm-link">
                                                <span className="icon-3" />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;